import styled from 'styled-components';
import { theme } from 'theme/theme';
import Button from 'components/Button';
import SchoolLogo from 'components/SchoolLogo';

export const Tab = styled.span<{ active: boolean }>`
  font-family: Roboto-Medium;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: ${props => (props.active ? theme.colors.white : theme.colors.white500)};
  border-bottom: 5px solid ${props => (props.active ? theme.colors.white : 'transparent')};
  margin: 3px 20px;
  cursor: pointer;
`;

export const DashboardButton = styled(Button)`
  margin-top: 8px;
  border: 1px solid ${theme.colors.white};
  color: ${theme.colors.white};
  background: transparent;
  padding: 6px 12px;
  border-radius: 3px;
  i {
    color: ${theme.colors.white};
  }
  &:hover {
    background: transparent;
    border: solid 1px ${theme.colors.disabledGrey};
    color: ${theme.colors.white};
    i {
      color: ${theme.colors.white};
    }
  }  
`;

export const StyledSchoolLogo = styled(SchoolLogo)<{$smallFormat: boolean;}>`
  width:${({ $smallFormat }) => ($smallFormat ? '64' : '130')}px;
  height:${({ $smallFormat }) => ($smallFormat ? '50' : '100')}px;
  border-radius: 0;
`;

export const OptionsMenuCard = styled.div`
  background-color: #416cee;
  margin-top: 60px;
  padding: 32px 35px;
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 12;
`;

export const OptionsMenuRow = styled.div`
`;

export const OptionsMenuCol = styled.div`
`;
